var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flavors && _vm.flavors.length > 0)?_c('div',{staticClass:"coa-list grid grid-col-4 col-span-4"},_vm._l((_vm.formattedFlavors),function(flavor,name){return _c('div',{key:`flavor-${name}`},[_c('coa-item',{attrs:{"flavor":flavor}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }